import { render, staticRenderFns } from "./AdminGame.vue?vue&type=template&id=93ed8e2a&"
import script from "./AdminGame.vue?vue&type=script&lang=js&"
export * from "./AdminGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports